import animation, { fadeIn } from '@helpers/animation';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import svgBackground from '@img/general/footer-bg.svg';
import BackToTopStyles from '@stories/Components/Footer/BackToTop/BackToTop.styles';
import ContactDetailsStyles from '@stories/Components/Footer/ContactDetails/ContactDetails.styles';
import FooterLinksStyles from '@stories/Components/Footer/FooterLinks/FooterLinks.styles';
import SocialLinksStyles from '@stories/Components/Footer/SocialLinks/SocialLinks.styles';
import SiteWideStyles from '@stories/Components/Global/SiteWide/SiteWide.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  background: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};

  @media ${from(Device.TabletLarge)} {
    ${() => TopSection}, ${() => BottomSection} {
      opacity: 0;
    }

    ${({ isActive }) => isActive &&
    css `
        ${() => TopSection} {
          ${fadeIn(isActive, 375, 0, animation.easeInOutCubic)};
        }

        ${() => BottomSection} {
          ${fadeIn(isActive, 375, 150, animation.easeInOutCubic)};
        }
      `}
  }
`;
const TopSection = styled.div `
  padding: 32px 0 24px;
  text-align: center;

  @media ${from(Device.Tablet)} {
    background-image: url('${svgBackground}');
    background-repeat: no-repeat;
    background-position: bottom right;
    padding: 60px 0px;
    text-align: left;
  }

  @media ${from(Device.DesktopLarge)} {
    padding: 72px 0;
  }

  ${SiteWideStyles.Container} {
    display: grid;
    align-items: flex-start;
    gap: 20px;
    grid-template-columns: repeat(6, 1fr);
    height: 100%;

    @media ${from(Device.TabletLarge)} {
      gap: 30px;
      grid-template-columns: repeat(12, 1fr);
    }
  }

  ${BackToTopStyles.Container} {
    grid-column: span 3;
    justify-self: flex-end;
    margin: 10px 0 0;

    @media ${from(Device.TabletLarge)} {
      grid-column: 7 / span 6;
    }
  }

  ${ContactDetailsStyles.Container},
  ${FooterLinksStyles.Container},
  ${SocialLinksStyles.Container} {
    grid-column: 1 / span 6;

    @media ${from(Device.Tablet)} {
      grid-column: span 3;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: span 3;
    }
  }
`;
const LogoWrapper = styled.div `
  grid-column: span 3;
  margin: 0 0 32px;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
  }

  @media ${from(Device.DesktopLarge)} {
    margin: 0 0 64px;
  }
`;
const LogoLink = styled.a `
  display: block;
  color: currentColor;
`;
const Logo = styled.span `
  display: block;
  max-width: 160px;
  width: 100%;
`;
const BottomSection = styled.div `
  padding: 0 0 48px;

  hr {
    display: block;
    border: 0;
    border-top: 1px solid ${cssVar('accentColor')};
    height: 1px;
    margin: 0 0 10px 0;
    width: 100%;
  }
`;
const BottomSectionInner = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;

  @media ${from(Device.TabletLarge)} {
    flex-direction: row;
  }
`;
const LegalStatementWrapper = styled.div `
  display: flex;
  align-items: center;
  margin: 30px 0 0;
  text-align: center;

  @media ${until(Device.MobileLarge)} {
    flex-direction: column;

    ${() => LegalStatement} {
      margin-top: 10px;
    }
  }

  @media ${from(Device.Tablet)} {
    text-align: left;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span 3;
    margin: 0;
    margin-left: auto;
    padding-left: 32px;
  }
`;
const LegalLogo = styled.span `
  display: inline-block;
  flex: 0 0 auto;
  margin-right: 30px;
`;
const LegalStatement = styled.div `
  ${fonts.gillSans.regular};
  font-size: 12px;
  line-height: 18px;

  strong {
    ${fonts.gillSans.semiBold};
  }

  @media ${from(Device.Tablet)} {
    font-size: 14px;
    line-height: 22px;
  }
`;
export default {
    BottomSection,
    BottomSectionInner,
    Container,
    LegalLogo,
    LegalStatement,
    LegalStatementWrapper,
    Logo,
    LogoLink,
    LogoWrapper,
    TopSection,
};
